const getAllMatches = (source, regex) => {
  const matches = [];
  if (source) {
    source.replace(regex, function () {
      matches.push({
        match: arguments[0],
        offset: arguments[arguments.length - 2],
        groups: Array.prototype.slice.call(arguments, 1, -2),
      });
      return arguments[0];
    });
    return matches;
  }
  return matches;
};

const loadScript = (props, children, onLoad, onError) => {
  const script = document.createElement('script');

  script.setAttribute('data-ot-ignore', '');

  if (children) {
    const inlineScript = document.createTextNode(children);
    script.appendChild(inlineScript);
  }

  if (props) {
    for (const [attr, value] of Object.entries(props)) {
      script.setAttribute(attr, value);
    }
  }

  if (onLoad) {
    script.onload = onLoad
  }

  if (onError) {
    script.onerror = onError
  }

  document.head.appendChild(script)
  return script;
}

const removeScript = (script) => {
  if (script) {
    document.head.removeChild(script);
  }
}

export {
  getAllMatches,
  loadScript,
  removeScript,
}
